import { render, staticRenderFns } from "./CourseDrawer.vue?vue&type=template&id=a7628314"
import script from "./CourseDrawer.vue?vue&type=script&lang=js"
export * from "./CourseDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports